import axios from 'axios'
import {FC, useState} from 'react'
import {useAuth} from '../../../../../auth'
import {API_URL} from '../../../../../../../_metronic/helpers'
import {useBusinessSwitcherLabels} from '../../../../shared/business-switcher/businessSwitcherLabels'
import {
  BusinessSelect,
  readBusinessChangeError,
} from '../../../../shared/business-switcher/BusinessSelect'
import {confirmLeavingUnsavedWork} from '../../../../shared/business-switcher/unsavedWork'

type props = {
  comboStyle?: React.CSSProperties
}

/** The selected business, as a searchable combo over the user's businesses; choosing one reloads the page with it. */
const ChangeCompany: FC<props> = ({comboStyle}) => {
  const {currentUser, setCurrentUser, saveAuth} = useAuth()
  const shown = !!currentUser
  const labels = useBusinessSwitcherLabels(shown ? currentUser?.cpl : undefined)
  const [changing, setChanging] = useState<number>()
  const [error, setError] = useState('')

  if (!shown) return null

  const setCompany = (companyId: number) => {
    if (changing !== undefined || companyId === Number(currentUser?.cpi)) return
    if (!confirmLeavingUnsavedWork()) return
    setChanging(companyId)
    setError('')
    axios
      .post(`${API_URL}/auth/changeCompany`, {compnyId: companyId})
      .then((response) => {
        saveAuth(response.data)
        setCurrentUser(response.data)
        window.location.reload()
      })
      .catch((changeError) => {
        setChanging(undefined)
        setError(readBusinessChangeError(changeError))
      })
  }

  return (
    <div className='mp-business-select' style={{marginBottom: comboStyle?.marginBottom}}>
      <BusinessSelect
        businesses={currentUser?.cpl || []}
        labels={labels}
        value={Number(currentUser?.cpi)}
        onChange={setCompany}
        isLoading={changing !== undefined}
        isDisabled={changing !== undefined}
      />
      {error && (
        <div className='text-danger fs-8 mt-1' role='alert'>
          {error}
        </div>
      )}
    </div>
  )
}

export {ChangeCompany}
